import { ItemListEntry, PlannedListFilterType } from "../pages/MaterialIssue";
import { getInventoryTypeControl } from "../api/InControl";

export const fetchInventoryConditions = async (itemList: ItemListEntry[]) => {
  const conditions = await Promise.all(
    itemList.map(async (item) => {
      const response = await getInventoryTypeControl(item.item?.ItemType);
      return {
        itemType: item.item?.ItemType,
        automaticIssueUponReceipt: response?.data[0].AutomaticIssueUponReceipt,
        itemTableDefinition: response?.data[0].ItemTableDefinition,
      };
    })
  );

  const conditionMap = conditions.reduce((acc, condition) => {
    acc[condition.itemType] = condition;
    return acc;
  }, {} as Record<string, { automaticIssueUponReceipt: boolean; itemTableDefinition: string }>);
  return conditionMap;
};


export const matchesItemNotFullyIssued = (
  entry: ItemListEntry,
  currentFilter?: PlannedListFilterType
) => {
  return (
    currentFilter === PlannedListFilterType.ItemsNotFullyIssued &&
    (
      entry.item?.LineQuantityRequested > entry.item?.LineQuantityIssued ||
      (entry.item?.LineQuantityRequested === 0 && entry.item?.LineQuantityIssued === 0)
    )
  );
};

export const matchesAvailableItemsNotFullyIssued = (
  entry: ItemListEntry,
  currentFilter?: PlannedListFilterType
) => {
  return (
    currentFilter === PlannedListFilterType.AvailableItemsNotFullyIssued &&
    (
      entry.item?.LineQuantityRequested > entry.item?.LineQuantityIssued ||
      (entry.item?.LineQuantityRequested === 0 && entry.item?.LineQuantityIssued === 0)
    ) &&
    entry.item?.LocationQuantityAvailable > 0
  );
};